"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var react_1 = __importStar(require("react"));
var UseAutomationsMetadata_1 = require("Library/AutomationLibrary/hooks/UseAutomationsMetadata");
var inversify_react_1 = require("inversify-react");
var useAutomationsTelemetry_1 = require("Library/AutomationLibrary/hooks/useAutomationsTelemetry");
var useIntegrationSetup = function () {
    var accountDataStore = (0, inversify_react_1.useInjection)("rootDataStore").getAccountDataStore();
    var automationsMetadata = (0, UseAutomationsMetadata_1.useAutomationsMetadata)();
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var _a = __read((0, react_1.useState)(false), 2), isSetup = _a[0], setIsSetup = _a[1];
    var telemetry = (0, useAutomationsTelemetry_1.useAutomationsTelemetry)(Types_1.ProviderType.Hubspot);
    var showEnableHubspotModal = (0, react_1.useCallback)(function (action) {
        modalService.showConfirmModal({
            title: "Please ".concat(action === "enable" ? "enable" : "re-enable", " the HubSpot integration to use automations"),
            explainer: (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement("p", null,
                        action === "enable" ? "Enable" : "Disable and enable",
                        " your HubSpot integration to explore all automation features."),
                    action === "reEnable" && (react_1.default.createElement("p", null, "Your existing templates and tokens attached to HubSpot will be automatically reconnected."))),
                react_1.default.createElement("img", { src: "Assets/Images/integrations/qwilr-plus-hubspot.png" }))),
            confirmLabel: "Take me there",
            cancelLabel: "Do it later",
            isEscapable: false,
            confirming: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    window.location.href = "#/settings/integrations/hubspot";
                    return [2];
                });
            }); },
        });
    }, [modalService]);
    (0, react_1.useEffect)(function () {
        if (automationsMetadata.data === undefined) {
            return;
        }
        var isHubspotEnabled = accountDataStore.integrations.hubspot.enabled;
        var isHubspotEnabledForAutomations = automationsMetadata.data.some(function (metadata) { return metadata.integrationName === Types_1.ProviderType.Hubspot; });
        if (!isHubspotEnabled || !isHubspotEnabledForAutomations) {
            automationsMetadata.clear();
            showEnableHubspotModal(!isHubspotEnabled ? "enable" : "reEnable");
            telemetry.trackHubspotReEnableModalShown();
            setIsSetup(false);
        }
        else {
            setIsSetup(true);
        }
    }, [accountDataStore.integrations.hubspot.enabled, automationsMetadata, showEnableHubspotModal]);
    return isSetup;
};
exports.default = useIntegrationSetup;
